import { render, staticRenderFns } from "./TextareaRow.vue?vue&type=template&id=52ffe6a6&"
import script from "./TextareaRow.vue?vue&type=script&lang=js&"
export * from "./TextareaRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports